import { render, staticRenderFns } from "./InsuranceReport.vue?vue&type=template&id=399e09f0&scoped=true"
import script from "./InsuranceReport.vue?vue&type=script&lang=js"
export * from "./InsuranceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399e09f0",
  null
  
)

export default component.exports